import './src/vaadin-map.js';
export * from './src/vaadin-map.js';
